import React, { useEffect, createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = React.createContext({
  token: "",
  isLoggedIn: false,
  loginHandler: (token) => {},
  logoutHandler: () => {},
  login: (username, password) => {},
  logout: () => {},
  // copyItem: null,

  //** Copy Item */
  isCoppiedItem: false,
});

export const useAuth = () => useContext(AuthContext);

export const AuthContextProvider = (props) => {
  const navigate = useNavigate();

  const [isCoppiedItem, setIsCoppiedItem] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState("taken name");
  const useIsLoggedIn = !!token;

  useEffect(() => {
    const storedUserLoggedInInformation = localStorage.getItem("isLoggedIn");

    //alert("Load..");

    if (storedUserLoggedInInformation === "1") {
      setIsLoggedIn(true);
    }
  }, []);

  const loginHandler = (token) => {
    setToken(token);
  };

  const logoutHandler = () => {
    setToken(null);
  };

  const setCopyItemState = (value) => {
    setIsCoppiedItem(value);
  };

  const login = (username, password) => {
    // alert("user name submitted: " + username);
    if (username === "admin" && password === "miraz71") {
      //alert("Login success : " + username);
      localStorage.setItem("isLoggedIn", "1");
      setIsLoggedIn(true);
      //navigate("/");
    } else {
      // alert("Login Failed : " + username);
      setIsLoggedIn(false);
    }
    // Here you can call your API to authenticate the user
    // If authentication is successful, set isLoggedIn to true
    //alert("user name submitted: " + username);
  };

  const logout = () => {
    // Here you can call your API to log the user out
    // If log out is successful, set isLoggedIn to false
    setIsLoggedIn(false);
    localStorage.removeItem("isLoggedIn");
    // alert("let's logout");
  };

  // const contextValue = {
  //   token: token,
  //   isLoggedIn: isLoggedIn,
  //   loginHandler: loginHandler,
  //   logoutHandler: logoutHandler,
  //   login: login,
  //   logout: logout,
  // };

  return (
    <AuthContext.Provider
      value={{
        token,
        isLoggedIn,
        login,
        logout,
        loginHandler,
        logoutHandler,
        setCopyItemState,
        isCoppiedItem,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
